import { render, staticRenderFns } from "./SidebarLiveOrdersBadge.vue?vue&type=template&id=266cd237&scoped=true&"
import script from "./SidebarLiveOrdersBadge.vue?vue&type=script&lang=ts&"
export * from "./SidebarLiveOrdersBadge.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarLiveOrdersBadge.vue?vue&type=style&index=0&id=266cd237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266cd237",
  null
  
)

export default component.exports